import { Box, Container, Typography } from '@mui/material';
import { ExerciseManagement } from 'components/templates';
import React from 'react';

export const ExercisesView = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'left' }}>
          Exercises
        </Typography>
      </Box>
      <ExerciseManagement />
    </Container>
  );
};
